export default [{
    path: '/priceParitySetting',
    name: 'priceParitySetting',
    meta: {
        title: '比价设置'
    },
    component: resolve => {
        require(['@components/priceParity/priceParitySetting'], resolve)
    },
}]